var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfflineMachines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 31,
    viewBox: "0 0 28 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6312 9.80882C12.6512 9.54832 12.8684 9.34717 13.1297 9.34717H13.5475C13.8044 9.34717 14.0195 9.54182 14.045 9.79742L14.6667 16.0138L19.0814 18.5365C19.2372 18.6256 19.3333 18.7912 19.3333 18.9707V19.3592C19.3333 19.6889 19.0199 19.9283 18.7018 19.8416L12.3987 18.1226C12.1673 18.0595 12.0133 17.841 12.0317 17.6018L12.6312 9.80882Z",
    fill: "#FF9066"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.901274,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.72176 0.984343C6.45765 0.669594 5.94771 0.790064 5.85238 1.18973L4.21891 8.03786C4.14123 8.36351 4.39931 8.67201 4.73356 8.65307L11.7783 8.25386C12.1892 8.23057 12.3976 7.74855 12.133 7.43327L10.3316 5.28642C11.4965 4.88837 12.7317 4.68047 14 4.68047C20.2592 4.68047 25.3333 9.75458 25.3333 16.0138C25.3333 22.273 20.2592 27.3471 14 27.3471C7.74077 27.3471 2.66667 22.273 2.66667 16.0138C2.66667 14.963 2.80896 13.9339 3.08641 12.9448L0.518845 12.2245C0.180793 13.4297 0 14.7006 0 16.0138C0 23.7458 6.26801 30.0138 14 30.0138C21.732 30.0138 28 23.7458 28 16.0138C28 8.28182 21.732 2.0138 14 2.0138C12.0551 2.0138 10.2029 2.41038 8.51973 3.12708L6.72176 0.984343Z",
    fill: "#FF9066"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfflineMachines);
export default __webpack_public_path__ + "static/media/Offline Machines.9fd15b52fe9f9adbc9653036dc1fadb3.svg";
export { ForwardRef as ReactComponent };